import "./index.scss";

import { Component, Vue } from "vue-property-decorator";

import IconSvg from "@/components/Icon-svg";
import { DragDetail } from "@/shared/directives/drag";
import { local } from "@/shared/utils/storage";
import { debugWindow } from "@/components/debug-window";

@Component({ name: "DebugTool" })
export default class DebugTool extends Vue {
  private right: number = local.get("DEBUG_TOOL_POSITION_RIGHT") || 10;

  private bottom: number = local.get("DEBUG_TOOL_POSITION_BOTTOM") || 70;

  private preRight: number = this.right;

  private preBottom: number = this.bottom;

  private get style() {
    return {
      right: `${this.right}px`,
      bottom: `${this.bottom}px`,
    };
  }

  private onDrag(e: CustomEvent<DragDetail>) {
    const { deltaX, deltaY } = e.detail;
    if (this.preRight - deltaX >= 0 && this.preBottom - deltaY >= 0) {
      this.right = this.preRight - deltaX;
      this.bottom = this.preBottom - deltaY;
    }
  }

  private dragEnd() {
    this.preRight = this.right;
    local.set("DEBUG_TOOL_POSITION_RIGHT", this.right);
    this.preBottom = this.bottom;
    local.set("DEBUG_TOOL_POSITION_BOTTOM", this.bottom);
  }

  private onClick() {
    if (!debugWindow.isOpen) {
      debugWindow.open();
    } else {
      debugWindow.close();
    }
  }

  private render() {
    return (
      <div
        v-class
        v-drag
        onDrag={(e: CustomEvent<DragDetail>) => this.onDrag(e)}
        onDragEnd={() => this.dragEnd()}
        style={this.style}
        onClick={this.onClick}
      >
        <IconSvg iconClass="debug" />
      </div>
    );
  }
}

document.body.appendChild(new DebugTool().$mount().$el);
